"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Toast_1 = __importDefault(require("acl-ui/components/Toast"));
var l10n_1 = require("@paprika/l10n");
var prop_types_1 = __importDefault(require("prop-types"));
function ToastNotification(_a) {
    var handleClose = _a.handleClose;
    var i18n = l10n_1.useI18n();
    return (react_1.default.createElement(Toast_1.default, { sticky: true, onClosed: function () {
            handleClose();
        } }, i18n.t('left_navigation.hidden_target')));
}
exports.default = ToastNotification;
ToastNotification.propTypes = {
    handleClose: prop_types_1.default.func,
};
//# sourceMappingURL=ToastNotification.js.map